import workspaceQuery from '../../../graphql/queries/sales/ImportedMagentoOrderWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/sales/ImportedMagentoOrderListQuery.graphql';
import instanceQuery from '../../../graphql/queries/sales/ImportedMagentoOrderQuery.graphql';
import mutationQuery from '../../../graphql/mutations/sales/ImportedMagentoOrderMutation.graphql';
import fragment from '../../../graphql/fragments/sales/ImportedMagentoOrderFragment.graphql';
import aggregateQuery from '../../../graphql/queries/sales/ImportedMagentoOrderAggregateQuery.graphql';

import { workspace } from '../../../actions/sales/ImportedOrderWorkspaceAction';
import { ALLOW_VIEW } from '../../../utils/OperationPermissions';
import { EntityType } from '../../../@types/entityTypes';

const ImportedMagentoOrder: EntityType = {
  type: 'ImportedMagentoOrder',
  title: 'Magento Orders',
  formTitle: 'Imported Magento Order',
  workspaceUrl: '/Sales/Channel/ImportedMagentoOrder/Workspace/',
  formUrl: '/Sales/Channel/ImportedMagentoOrder/Details/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'orderReference',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'IMPORTED_MAGENTO_ORDERS',
  actions: workspace,
  operations: ALLOW_VIEW,
};

export default ImportedMagentoOrder;
